import * as Sentry from '@sentry/browser'
import type { NavigationMeasurement } from '../facade/js/liveview'

// Public functions ------------------------------------------------------------

/** Keep one local timing entry and send sampled production spans with real timestamps. */
export const reportNavigation = (measurement: NavigationMeasurement): void => {
  performance.clearMeasures('hq.navigation')
  performance.measure('hq.navigation', {
    start: measurement.startMs,
    end: measurement.endMs,
    detail: measurement
  })

  if (process.env.NODE_ENV !== 'production' || !Sentry.getClient()) {
    return
  }

  const span = Sentry.startInactiveSpan({
    name: `liveview.navigation ${measurement.page}`,
    op: 'ui.navigation',
    parentSpan: null,
    startTime: (performance.timeOrigin + measurement.startMs) / 1000,
    attributes: {
      'navigation.kind': measurement.kind,
      'navigation.outcome': measurement.outcome,
      'navigation.page': measurement.page,
      'navigation.duration_ms': measurement.endMs - measurement.startMs,
      'navigation.response_ms': measurement.responseMs,
      'navigation.content_wait_ms':
        measurement.responseMs === undefined
          ? undefined
          : measurement.endMs - measurement.startMs - measurement.responseMs
    }
  })
  span.end((performance.timeOrigin + measurement.endMs) / 1000)
}
